import {
  getCurrentTimezone,
  getCityNames,
  getCurrentCity,
  setCurrentCity,
  getTemperatureString,
  fetchAll,
} from './weather'
import { capitalizeFirstLetter } from './utils/stringUtils'

export function init() {
  fetchAll().then(() => {
    const $citySelect = createCitySelect()

    updateCurrentWeather()

    updateCurrentTime()
    setInterval(updateCurrentTime, 5 * 1000)

    $(document).on('cityChange', () => {
      $citySelect.val(getCurrentCity().name)
      updateCurrentTime()
      updateCurrentWeather()
    })

    showHeaderItems()
  })
}

function showHeaderItems() {
  $('.header-item.hide').removeClass('hide')
}

function updateCurrentTime() {
  $('[data-header-item-datetime]').text(formatDateTime(getCurrentTimezone()))
  $('[data-header-item-short-datetime]').text(formatDate(getCurrentTimezone()))
}

function updateCurrentWeather() {
  $('[data-header-item-weather]').text(formatWeather(getCurrentCity()))
  $('[data-header-item-short-weather]').text(formatShortWeather(getCurrentCity()))
}

function createCitySelect() {
  const cities = getCityNames()
  const selects = []
  $('[data-header-item-location-selector]').each((i, el) => {
    const $select = buildSelect(cities)
    $select.val(getCurrentCity().name)
    $select.on('change', () => setCurrentCity($select.val()))
    $(el).append($select)
    selects.push($select)
  })
  return $(selects)
}

/**
 * @param {string[]} options
 */
function buildSelect(options) {
  return $(`<select>${options.map((v) => `<option value="${v}">${v}</option>`).join('')}</select>`)
}

/**
 * @param {string} timeZone
 */
function formatDateTime(timeZone) {
  const date = new Date()
  return new Intl.DateTimeFormat('en-AU', {
    hour12: true,
    // weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timeZone,
    timeZoneName: 'short',
  }).format(date)
}

function formatDate(timeZone) {
  const date = new Date()
  return new Intl.DateTimeFormat('en-AU', {
    // weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: timeZone,
  }).format(date)
}

function formatWeather(city) {
  const temp = getTemperatureString(city.main.temp_min, city.main.temp_max)
  // return `${temp} ${capitalizeFirstLetter(city.weather[0].description)}`;
  return temp
}

function formatShortWeather(city) {
  const temp = getTemperatureString(city.main.temp_min, city.main.temp_max)
  return `${temp}`
}
